module["exports"] = [
  "#####"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/uk/address/postcode.js
// module id = 1611
// module chunks = 1